import { useState } from "react";
import restAPI from "@app/config/apiConfig";

const PersonaFormAPI = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const [response, setResponse] = useState("");

	const getPersonaForm = () => {
		setLoading(true);
		setError("");
		setResponse("");

		restAPI
			.get(`rulesets`)
			.then(({ data }) => {
				setResponse(data);
			})
			.catch(() => {
				setError("Failed to call API, maybe you are disconnected!");
			})
			.finally(() => {
				setLoading(false);
			});
	};

	const submitPersonaForm = (data) => {
		setLoading(true);
		setError("");
		setResponse("");

		restAPI
			.post("rulesets", data)
			.then(({ data }) => {
				setResponse(data);
				setTimeout(() => {
					// Change the current url page parameter to edit slug.
					const url = new URL(window.location.href);
					url.searchParams.set("page", "dxp-toolkit-edit-persona");
					url.searchParams.set("id", data.data.id);
					window.location.href = url.href;
				}, 5000);
			})
			.catch((error) => {
				if (error.data?.message) {
					setError(error.data.message);
				} else if (error) {
					setError("Failed to call API, maybe you are disconnected!");
				}
			})
			.finally(() => {
				setLoading(false);
			});
	};

	const updatePersonaForm = (data) => {
		setLoading(true);
		setError("");
		setResponse("");

		restAPI
			.put(`rulesets/${data.id}`, data)
			.then(({ data }) => {
				setResponse(data);
			})
			.catch((error) => {
				if (error.data?.message) {
					setError(error.data.message);
				} else if (error) {
					setError("Failed to call API, maybe you are disconnected!");
				}
			})
			.finally(() => {
				setLoading(false);
			});
	};

	const deletePersonaFrom = (id) => {
		setLoading(true);
		setError("");
		setResponse("");

		restAPI
			.delete(`rulesets/${id}`)
			.then(({ data }) => {
				setResponse(data);
				// Redirect to dashboard page after 1 second.
				setTimeout(() => {
					window.location.href = window.CFCCAdmin.dashboardUrl;
				}, 1000);
			})
			.catch((error) => {
				if (error.data?.message) {
					setError(error.data.message);
				} else if (error) {
					setError("Failed to call API, maybe you are disconnected!");
				}
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return {
		error,
		getPersonaForm,
		loading,
		response,
		submitPersonaForm,
		updatePersonaForm,
		deletePersonaFrom,
	};
};

export default PersonaFormAPI;
